import React, {useState} from 'react';
import {Button, TextField} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {setAuthState, signOut} from '../../store/slices/authSlice';
import {toast} from 'react-toastify';
import api from '../../api/axios';
import {useNavigate} from 'react-router-dom';
import {getAuthStateFromLocalStorage} from '../utils/LocalStorageAuth';

const MfaVerificationForm: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isPending, setIsPending] = useState(false);
  const [mfaCode, setMfaCode] = useState('');

  const handleVerifyMfa = async () => {
    setIsPending(true);

    try {
      const mfaPromise = api.post('/sign-in/mfa', {mfaCode});
      const res = await toast.promise(mfaPromise, {
        pending: t('toastify.pending'),
        success: t('signIn.success'),
        error: t('signIn.mfaInvalid')
      });

      dispatch(setAuthState(getAuthStateFromLocalStorage(res.data)));

      navigate('/');
    } catch (err) {
      dispatch(signOut());
    } finally {
      setIsPending(false);
    }
  };

  return (
      <div className="flex flex-col items-center justify-start md:justify-center mt-40 md:mt-0 min-h-screen bg-light dark:bg-dark px-4">
        <div className="w-full max-w-sm p-6 rounded-2xl shadow-lg bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700">
          <h2 className="text-2xl font-bold text-center text-light-text dark:text-dark-text mb-6">
            {t('signIn.enterMfaCode')}
          </h2>
          <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
            <TextField
                label={t('signIn.mfaCode')}
                fullWidth
                value={mfaCode}
                onChange={(e) => setMfaCode(e.target.value)}
            />
            <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleVerifyMfa}
                disabled={isPending}
            >
              {t('signIn.verifyMfa')}
            </Button>
          </form>
        </div>
      </div>
  );
};

export default MfaVerificationForm;
